// sof-crosssell.js — PDP cross-sell (2026-09-07). Two modules, one data source:
// the API-only section `sof-upsell-feed`, fetched per collection in Shopify's
// native best-selling order with each product's EXACT breed metafield.
//   <sof-complete-set>  same breed + same line, other formats (under buy box)
//   <sof-more-breed>    same breed best sellers; reorders the server-rendered cards
(function () {
  if (window.__sofCrosssell) return; window.__sofCrosssell = true;
  const feedCache = {};
  function fetchFeed(handle) {
    if (!handle) return Promise.resolve([]);
    if (!feedCache[handle]) {
      feedCache[handle] = fetch(`/collections/${handle}?sort_by=best-selling&section_id=sof-upsell-feed`, { headers: { Accept: 'text/html' } })
        .then(r => (r.ok ? r.text() : ''))
        .then(html => {
          const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sof-upsell-feed]');
          return node ? (JSON.parse(node.textContent) || []).filter(Boolean) : [];
        })
        .catch(() => []);
    }
    return feedCache[handle];
  }
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, m => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m]));
  const TYPE_ORDER = ['Pillow', 'Blanket', 'Coaster', 'Tote Bag', 'Wrapping Paper'];
  const typeRank = t => { const i = TYPE_ORDER.indexOf(t); return i < 0 ? 99 : i; };

  // ── Complete the set ──
  class SofCompleteSet extends HTMLElement {
    connectedCallback() { this.load(); }
    async load() {
      const { breed, line, coll, ptype, handle } = this.dataset;
      const list = this.querySelector('[data-sof-set-list]');
      if (!list) return;
      // Prefer the line collection (same theme); fall back to the breed collection.
      let items = (await fetchFeed(line)).filter(p => p.breed === breed && p.handle !== handle && p.ptype && p.ptype !== ptype);
      let source = 'line';
      if (items.length < 2 && coll) {
        const more = (await fetchFeed(coll)).filter(p => p.breed === breed && p.handle !== handle && p.ptype && p.ptype !== ptype);
        const seen = new Set(items.map(p => p.handle));
        for (const p of more) if (!seen.has(p.handle)) { items.push(p); seen.add(p.handle); }
        if (!items.length) source = 'breed';
      }
      // one per format (best seller of that format), formats in a fixed order, max 4
      const byType = new Map();
      for (const p of items) if (!byType.has(p.ptype)) byType.set(p.ptype, p);
      const picks = [...byType.values()].sort((a, b) => typeRank(a.ptype) - typeRank(b.ptype)).slice(0, 4);
      window.__sofSetHandles = new Set(picks.map(p => p.handle));
      document.dispatchEvent(new CustomEvent('sof:set-ready'));
      if (!picks.length) { this.remove(); return; }
      list.innerHTML = picks.map(p => {
        const rating = Number(p.rating) || 0, count = Number(p.rating_count) || 0;
        const multi = p.ptype === 'Wrapping Paper';
        return `
        <article class="sof-upsells__card">
          <a class="sof-upsells__thumb-link" href="/products/${esc(p.handle)}" aria-label="${esc(p.title)}">
            ${p.image ? `<img class="sof-upsells__thumb" src="${esc(p.image)}" alt="" loading="lazy" width="104" height="104">` : ''}
          </a>
          <div class="sof-upsells__body">
            <a class="sof-upsells__title-link" href="/products/${esc(p.handle)}">${esc(p.title)}</a>
            <span class="sof-upsells__meta">
              ${count > 0 ? `<span class="sof-upsells__stars" role="img" aria-label="${rating.toFixed(1)} out of 5 stars, ${count} reviews"><span class="sof-upsells__stars-fill" style="width:${Math.max(0, Math.min(100, rating / 5 * 100))}%"></span></span><span class="sof-upsells__count">(${count})</span>` : ''}
              ${p.price ? `<span class="sof-upsells__price">${esc(p.price)}</span>` : ''}
            </span>
            ${multi
              ? `<a class="sof-upsells__add sof-upsells__add--link" href="/products/${esc(p.handle)}">Choose size</a>`
              : `<button type="button" class="sof-upsells__add" data-handle="${esc(p.handle)}" aria-label="Add ${esc(p.title)} to cart">Add</button>`}
          </div>
        </article>`;
      }).join('');
      this.hidden = false;
      list.querySelectorAll('button.sof-upsells__add').forEach(btn => btn.addEventListener('click', () => this.add(btn)));
    }
    async add(btn) {
      const orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      try {
        const pr = await fetch(`/products/${btn.dataset.handle}.js`, { headers: { Accept: 'application/json' } });
        if (!pr.ok) throw new Error('product ' + pr.status);
        const prod = await pr.json();
        const variants = prod.variants || [];
        if (variants.length > 1) { window.location.href = `/products/${btn.dataset.handle}`; return; }
        const v = variants.find(x => x.available) || variants[0];
        if (!v) throw new Error('no variant');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
        });
        if (!res.ok) throw new Error('add ' + res.status);
        const data = await res.json();
        const sections = data.sections || {};
        if (sections['cart-drawer']) {
          const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const newInner = parsed.querySelector('.drawer__inner');
          const cur = document.querySelector('#CartDrawer .drawer__inner');
          if (newInner && cur) cur.replaceWith(newInner);
        }
        if (sections['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const nb = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble') || parsed.body.firstElementChild;
          const cb = document.querySelector('#cart-icon-bubble') || document.querySelector('.cart-count-bubble');
          if (nb && cb) cb.replaceWith(nb);
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sof-complete-set' });
        }
        btn.textContent = 'Added';
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1500);
      } catch (err) {
        console.error('sof-complete-set add failed', err);
        btn.textContent = orig; btn.disabled = false;
      }
    }
  }
  if (!customElements.get('sof-complete-set')) customElements.define('sof-complete-set', SofCompleteSet);

  // ── More {Breed} best sellers ──
  // Server renders up to 24 same-breed cards (collection order). We fetch the
  // breed feed, keep EXACT-breed products, drop the current product and anything
  // already in "Complete the set", order by best-selling with type diversity
  // (no 3 of one format in a row), and show the first `max`.
  class SofMoreBreed extends HTMLElement {
    connectedCallback() { this.load(); }
    async load() {
      const { coll, breed, handle } = this.dataset;
      const max = parseInt(this.dataset.max || '8', 10);
      const grid = this.querySelector('[data-sof-more-grid]');
      if (!grid) return;
      const cards = new Map();
      grid.querySelectorAll('[data-handle]').forEach(li => cards.set(li.dataset.handle, li));
      const feed = await fetchFeed(coll);
      if (!feed.length) { this.reveal(grid, max); return; }
      // wait (briefly) for Complete the set so we don't repeat its picks
      if (document.querySelector('sof-complete-set') && !window.__sofSetHandles) {
        await new Promise(res => { const t = setTimeout(res, 1500); document.addEventListener('sof:set-ready', () => { clearTimeout(t); res(); }, { once: true }); });
      }
      const skip = window.__sofSetHandles || new Set();
      const pool = feed.filter(p => p.breed === breed && p.handle !== handle && !skip.has(p.handle) && cards.has(p.handle));
      const out = [];
      while (pool.length && out.length < max) {
        const last2 = out.slice(-2).map(p => p.ptype);
        let pick = null;
        if (last2.length === 2 && last2[0] === last2[1]) pick = pool.find(p => p.ptype !== last2[0]);
        if (!pick) pick = pool[0];
        pool.splice(pool.indexOf(pick), 1); out.push(pick);
      }
      if (!out.length) { this.reveal(grid, max); return; }
      const frag = document.createDocumentFragment();
      out.forEach(p => { const li = cards.get(p.handle); li.hidden = false; frag.appendChild(li); });
      grid.querySelectorAll('[data-handle]').forEach(li => { if (!out.some(p => p.handle === li.dataset.handle)) li.remove(); });
      grid.prepend(frag);
    }
    reveal(grid, max) { // no feed: show the first `max` in server order
      grid.querySelectorAll('[data-handle]').forEach((li, i) => { if (i < max) li.hidden = false; else li.remove(); });
    }
  }
  if (!customElements.get('sof-more-breed')) customElements.define('sof-more-breed', SofMoreBreed);
})();
